

import { cachedFetch, DialogElement, Drawer } from '//www.paulfredrick.com/cdn/shop/t/1054/assets/theme.js?v=175157753402560083561790356938';
import { animate } from '//www.paulfredrick.com/cdn/shop/t/1054/assets/vendor.min.js?v=52426788336887041471790356546';

// ─── facetupdate listener ─────────────────────────────────────────────────────

var abortController = null;
var openElements = new Set();

document.addEventListener('facetupdate', async (event) => {
  if (abortController) abortController.abort();
  abortController = new AbortController();

  const url = event.detail.url;
  const sectionId = url.searchParams.get('sectionid');
  const shopifySection = document.getElementById(`shopify-section-${sectionId}`);

  shopifySection.classList.add('is-loading');

  const clonedUrl = new URL(url);
  clonedUrl.searchParams.delete('sectionid');
  history.replaceState({}, '', clonedUrl.toString());

  try {
    const tempContent = new DOMParser().parseFromString(
      await (
        await cachedFetch(url.toString(), { signal: abortController.signal })
      ).text(),
      'text/html'
    );

    Array.from(tempContent.querySelectorAll('details, facet-dialog')).forEach((item) => {
      if (openElements.has(item.id)) item.setAttribute('open', '');
    });

    const fetchedSection =
      tempContent.querySelector(`#shopify-section-${sectionId}`) ||
      tempContent.querySelector('.shopify-section')

    if (!fetchedSection) return;

    console.log("shopifySection: ", shopifySection)
    console.log("tempContent: ", tempContent)
    console.log("fetchedSection", fetchedSection)

    shopifySection.replaceChildren(
      ...document.importNode(fetchedSection, true).childNodes
    );

    shopifySection.classList.remove('is-loading');

    const scrollToElement = window.matchMedia('(min-width: 700px) and (max-width: 999px)').matches
      ? shopifySection.querySelector('.collection__results')
      : shopifySection.querySelector('.collection__results product-list');

    if (scrollToElement) {
      const scrollToBoundingRect = scrollToElement.getBoundingClientRect();
      if (scrollToBoundingRect.top < (parseInt(getComputedStyle(scrollToElement).scrollPaddingTop) || 0)) {
        scrollToElement.scrollIntoView({ block: 'start', behavior: 'smooth' });
      }
    }
  } catch (e) {
    console.error('facetupdate error:', e);
    shopifySection?.classList.remove('is-loading');
  }
});

// ─── facet-form.js ────────────────────────────────────────────────────────────

var FacetForm = class extends HTMLFormElement {
  constructor() {
    super();
    this.isDirty = false;
    this.addEventListener('change', this._onFormChanged.bind(this));
    this.addEventListener('submit', this._onFormSubmitted.bind(this));
  }

  connectedCallback() {
    Array.from(this.querySelectorAll('details, facet-dialog')).forEach((disclosureElement) => {
      if (disclosureElement.open) openElements.add(disclosureElement.id);
      disclosureElement.addEventListener('toggle', () => {
        if (disclosureElement.open) {
          openElements.add(disclosureElement.id);
        } else {
          openElements.delete(disclosureElement.id);
        }
      });
    });
  }

  _buildUrl() {
    const searchParams = new URLSearchParams(new FormData(this));
    const url = new URL(this.action);
    url.search = '';
    searchParams.forEach((value, key) => url.searchParams.append(key, value));
    ['page', 'filter.v.price.gte', 'filter.v.price.lte'].forEach((optionToClear) => {
      if (!url.searchParams.get(optionToClear)) url.searchParams.delete(optionToClear);
    });
    url.searchParams.set('sectionid', this.getAttribute('section-id'));
    return url;
  }

  _onFormChanged() {
    this.isDirty = true;
    if (this.hasAttribute('update-on-change')) {
      if (HTMLFormElement.prototype.requestSubmit) {
        this.requestSubmit();
      } else {
        this.dispatchEvent(new Event('submit', { cancelable: true }));
      }
    } else {
      cachedFetch(this._buildUrl().toString());
    }
  }

  _onFormSubmitted(event) {
    event.preventDefault();
    if (!this.isDirty) return;
    this.dispatchEvent(
      new CustomEvent('facetupdate', {
        bubbles: true,
        detail: { url: this._buildUrl() },
      })
    );
    this.isDirty = false;
  }
};

if (!window.customElements.get('facet-form'))
  window.customElements.define('facet-form', FacetForm, { extends: 'form' });

// ─── facet-link.js ────────────────────────────────────────────────────────────

var FacetLink = class extends HTMLAnchorElement {
  constructor() {
    super();
    this.addEventListener('click', this._onFacetUpdate.bind(this));
  }

  _onFacetUpdate(event) {
    event.preventDefault();
    const sectionId = event.target
      .closest('.shopify-section')
      .id.replace('shopify-section-', '');
    const url = new URL(this.href);
    url.searchParams.set('sectionid', sectionId);
    this.dispatchEvent(
      new CustomEvent('facetupdate', { bubbles: true, detail: { url } })
    );
  }
};

if (!window.customElements.get('facet-link'))
  window.customElements.define('facet-link', FacetLink, { extends: 'a' });

// ─── facet-sort-by.js ─────────────────────────────────────────────────────────

var FacetSortBy = class extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('listbox:change', this._onValueChanged.bind(this));
  }

  _onValueChanged(event) {
    const url = new URL(location.href);
    const sectionId = event.target
      .closest('.shopify-section')
      .id.replace('shopify-section-', '');
    url.searchParams.set('sort_by', event.detail.value);
    url.searchParams.set('sectionid', sectionId);
    url.searchParams.delete('page');
    this.dispatchEvent(
      new CustomEvent('facetupdate', { bubbles: true, detail: { url } })
    );
  }
};

if (!window.customElements.get('facet-sort-by'))
  window.customElements.define('facet-sort-by', FacetSortBy);

// ─── facet-apply-button.js ────────────────────────────────────────────────────

var FacetApplyButton = class extends HTMLButtonElement {
  constructor() {
    super();
    this.addEventListener('click', this._closeDrawer.bind(this));
    this.form.addEventListener('change', this._updateCount.bind(this));
    this.filterCountElement = document.createElement('span');
    this.appendChild(this.filterCountElement);
  }

  connectedCallback() {
    this._updateCount();
  }

  _updateCount() {
    const form = new FormData(this.form);
    this.filterCountElement.innerText = ` (${
      Array.from(form.values()).filter((item) => item !== '').length
    })`;
  }

  async _closeDrawer() {
    await this.closest('facet-drawer').hide();
  }
};

if (!window.customElements.get('facet-apply-button'))
  window.customElements.define('facet-apply-button', FacetApplyButton, { extends: 'button' });

// ─── facet-dialog.js ──────────────────────────────────────────────────────────

var FacetDialog = class extends DialogElement {
  get initialFocus() {
    return false;
  }
};

if (!window.customElements.get('facet-dialog'))
  window.customElements.define('facet-dialog', FacetDialog);

// ─── facet-drawer.js ──────────────────────────────────────────────────────────

var FacetDrawer = class extends Drawer {
  constructor() {
    super();
    this.addEventListener('dialog:after-hide', this._submitForm.bind(this));
  }

  _submitForm() {
    const form = this.querySelector('#facet-form');
    if (HTMLFormElement.prototype.requestSubmit) {
      form.requestSubmit();
    } else {
      form.dispatchEvent(new Event('submit', { cancelable: true }));
    }
  }
};

if (!window.customElements.get('facet-drawer'))
  window.customElements.define('facet-drawer', FacetDrawer);

// ─── facet-floating-filter.js ─────────────────────────────────────────────────

var FacetFloatingFilter = class extends HTMLElement {
  connectedCallback() {
    new IntersectionObserver(this._onFooterVisibilityChanged.bind(this), {
      rootMargin: '50px 0px',
    }).observe(document.querySelector('.shopify-section--footer'));
  }

  _onFooterVisibilityChanged(entries) {
    if (entries[0].isIntersecting) {
      animate(this, { opacity: 0, transform: 'translateY(15px)', visibility: 'hidden' }, { duration: 0.15 });
    } else {
      animate(this, { opacity: 1, transform: 'translateY(0)', visibility: 'visible' }, { duration: 0.15 });
    }
  }
};

if (!window.customElements.get('facet-floating-filter'))
  window.customElements.define('facet-floating-filter', FacetFloatingFilter);

// js/common/form/price-range.js
var PriceRange = class extends HTMLElement {
  connectedCallback() {
    this._abortController = new AbortController();
    this.rangeLowerBound = this.querySelector(
      'input[type="range"]:first-child'
    );
    this.rangeHigherBound = this.querySelector(
      'input[type="range"]:last-child'
    );
    this.textInputLowerBound = this.querySelector(
      'input[name="filter.v.price.gte"]'
    );
    this.textInputHigherBound = this.querySelector(
      'input[name="filter.v.price.lte"]'
    );
    this.textInputLowerBound.addEventListener(
      "focus",
      () => this.textInputLowerBound.select(),
      { signal: this._abortController.signal }
    );
    this.textInputHigherBound.addEventListener(
      "focus",
      () => this.textInputHigherBound.select(),
      { signal: this._abortController.signal }
    );
    this.textInputLowerBound.addEventListener(
      "change",
      (event) => {
        event.preventDefault();
        event.target.value = Math.max(
          Math.min(
            parseInt(event.target.value),
            parseInt(this.textInputHigherBound.value || event.target.max) - 1
          ),
          event.target.min
        );
        this.rangeLowerBound.value = event.target.value;
        this.rangeLowerBound.parentElement.style.setProperty(
          "--range-min",
          `${
            (parseInt(this.rangeLowerBound.value) /
              parseInt(this.rangeLowerBound.max)) *
            100
          }%`
        );
      },
      { signal: this._abortController.signal }
    );
    this.textInputHigherBound.addEventListener(
      "change",
      (event) => {
        event.preventDefault();
        event.target.value = Math.min(
          Math.max(
            parseInt(event.target.value),
            parseInt(this.textInputLowerBound.value || event.target.min) + 1
          ),
          event.target.max
        );
        this.rangeHigherBound.value = event.target.value;
        this.rangeHigherBound.parentElement.style.setProperty(
          "--range-max",
          `${
            (parseInt(this.rangeHigherBound.value) /
              parseInt(this.rangeHigherBound.max)) *
            100
          }%`
        );
      },
      { signal: this._abortController.signal }
    );
    this.rangeLowerBound.addEventListener(
      "change",
      (event) => {
        event.stopPropagation();
        this.textInputLowerBound.value = event.target.value;
        this.textInputLowerBound.dispatchEvent(
          new Event("change", { bubbles: true })
        );
      },
      { signal: this._abortController.signal }
    );
    this.rangeHigherBound.addEventListener(
      "change",
      (event) => {
        event.stopPropagation();
        this.textInputHigherBound.value = event.target.value;
        this.textInputHigherBound.dispatchEvent(
          new Event("change", { bubbles: true })
        );
      },
      { signal: this._abortController.signal }
    );
    this.rangeLowerBound.addEventListener(
      "input",
      (event) => {
        event.target.value = Math.min(
          parseInt(event.target.value),
          parseInt(this.textInputHigherBound.value || event.target.max) - 1
        );
        event.target.parentElement.style.setProperty(
          "--range-min",
          `${
            (parseInt(event.target.value) / parseInt(event.target.max)) * 100
          }%`
        );
        this.textInputLowerBound.value = event.target.value;
      },
      { signal: this._abortController.signal }
    );
    this.rangeHigherBound.addEventListener(
      "input",
      (event) => {
        event.target.value = Math.max(
          parseInt(event.target.value),
          parseInt(this.textInputLowerBound.value || event.target.min) + 1
        );
        event.target.parentElement.style.setProperty(
          "--range-max",
          `${
            (parseInt(event.target.value) / parseInt(event.target.max)) * 100
          }%`
        );
        this.textInputHigherBound.value = event.target.value;
      },
      { signal: this._abortController.signal }
    );
  }
  disconnectedCallback() {
    this._abortController.abort();
  }
};
if (!window.customElements.get("price-range")) {
  window.customElements.define("price-range", PriceRange);
}

// ─── exports ──────────────────────────────────────────────────────────────────

export {
  FacetApplyButton,
  FacetDialog,
  FacetDrawer,
  FacetFloatingFilter,
  FacetForm,
  FacetLink,
  FacetSortBy,
  PriceRange,
};